import type { ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';

import type { RowData } from '../types';
import { GUEST_TYPES } from '../types';

export const useLeadingColumns = (
  hasDayPrice: boolean,
  hasAdultChildPrice: boolean,
  dataSource: RowData[]
): ColumnsType<RowData> => {
  return useMemo(() => {
    const cols: ColumnsType<RowData> = [];

    if (hasDayPrice) {
      cols.push({
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: 100,
        render: (value: string, _, index: number) => {
          if (!hasAdultChildPrice) {
            return value;
          }

          const firstIndex = dataSource.findIndex((r) => r.type === value);
          const rowSpan = firstIndex === index ? GUEST_TYPES.length : 0;

          return {
            children: value,
            props: { rowSpan },
          };
        },
      });
    }

    if (hasAdultChildPrice) {
      cols.push({
        title: 'Guest',
        dataIndex: 'guest',
        key: 'guest',
        width: 80,
      });
    }

    return cols;
  }, [hasDayPrice, hasAdultChildPrice, dataSource]);
};
